import { useState } from 'react';
import ErrorForm from 'app/commons/components/ErrorForm';
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";

interface InputFormProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  required?: boolean;
  show?: boolean;
  handleChange?: (value: string, name?: string) => void;
}

const InputForm = ({
  label,
  error,
  required = false,
  show = true,
  type = 'text',
  handleChange,
  ...inputProps
}: InputFormProps) => {
  const [inputType, setInputType] = useState(type);

  if (!show) return null;

  const togglePasswordVisibility = () => {
    setInputType(prev => (prev === 'password' ? 'text' : 'password'));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    handleChange?.(value, name);
    inputProps.onChange?.(e);
  };

  return (
    <div className="form-input">
      {label && (
        <label className={required ? 'required' : ''}>{label}</label>
      )}

      <div className="position-relative mt-2">
        <input
          {...inputProps}
          type={inputType}
          className={`form-control ${inputProps.className}`}
          onChange={handleInputChange}
        />

        {type === 'password' && (
          <FontAwesomeIcon
            icon={inputType === 'password' ? faEyeSlash : faEye}
            onClick={togglePasswordVisibility}
            className="toggle-password cursor-pointer position-absolute"
          />

        )}
      </div>

      <ErrorForm error={error} />
    </div>
  );
};

export default InputForm;
